export default __webpack_public_path__ + "static/media/whiteK8s.7073c199.svg";